import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { Equipe } from 'src/app/models/equipe.model';
import { EquipeService } from 'src/app/services/equipe.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-priceBodyShopResumo',
  templateUrl: './priceBodyShopResumo.component.html',
  styleUrls: ['./priceBodyShopResumo.component.scss']
})
export class PriceBodyShopResumoComponent implements OnInit {

  equipes: Equipe[];
  displayedColumns: string[] = ['nome', 'perfil', 'custoHoraMedio', 'horaAlocacao', 'margemLiquida', 'receitaBruta'];
  dataSource = new MatTableDataSource<Equipe>();
  equipesFixo: Array<Equipe>;
  estimativaId: any;
  totalReceitaBruta: any;
  mediaPrecoHora: any;
  mediaMargemLiquida: any;
  constructor(protected equipeService: EquipeService,
    private activatedRouter: ActivatedRoute
  ) {

    //super(equipeService);
  }

  ngOnInit() {
    this.carregarEquipe();
  }
  carregarEquipe() {
    const estimativaId = this.activatedRouter.snapshot.params.id;
    return this.equipeService.getByPropostaId(estimativaId)
      .subscribe({
        next:
          result => {
            if (result) {
              this.equipes = result.items;

              this.equipesFixo = JSON.parse(JSON.stringify(this.equipes));

              this.dataSource = new MatTableDataSource<Equipe>(this.equipes);

              this.equipesFixo.forEach((equipe) => {
                equipe.receitaBruta = Number((equipe.baseHora * equipe.precoHora).toFixed(2));
              })
              this.totalReceitaBruta = this.equipesFixo.reduce((acc: number, curr: Equipe) =>
                acc + curr.receitaBruta
                , 0).toFixed(2);
              this.calcularTotais();
            }
          }
      }
    );
  }

  calcularTotais() {
    if (this.equipesFixo) {
      const valoresPh = this.equipes.reduce((acc: number, curr: Equipe) =>
        acc + Number(curr.precoHora)
        , 0);

      const avgPh = (valoresPh / this.equipesFixo.length) || 0;

      this.mediaPrecoHora = avgPh.toFixed(2);

      const valoresMl = this.equipesFixo.reduce((acc: number, curr: Equipe) =>
        acc + Number(curr.margemLiquida)
        , 0);

      const avgMl = (valoresMl / this.equipesFixo.length) || 0;

      this.mediaMargemLiquida = avgMl.toFixed(2);

      this.totalReceitaBruta = this.equipesFixo.reduce((acc: number, curr: Equipe) =>
        acc + curr.receitaBruta
        , 0).toFixed(2);
    }
  }

}
